/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The action for Guard module
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.0.0
 */

import { createAction } from '../../app/createAction';
import {
    CHECK_GUARD,
    CHECK_GUARD_ERROR,
    CHECK_GUARD_SUCCESSFUL,
    SET_GUARD_COMPONENT_KEY,
} from '../constants/actionConstants';
import {
    ICheckGuardAction,
    ICheckGuardErrorAction,
    ICheckGuardErrorPayload,
    ICheckGuardPayload,
    ICheckGuardSuccessfulAction,
    ICheckGuardSuccessfulPayload,
    ISetGuardComponentKeyPayload,
    TSetGuardComponentKeyAction,
} from '../types/actionTypes';

/*
* -------------------------------------------
*        CHECK GUARD (ALL PERMISSIONS)
* -------------------------------------------
*/

export const checkGuard = (payload: ICheckGuardPayload): ICheckGuardAction =>
    createAction(CHECK_GUARD, payload);

export const checkGuardSuccessful = (payload: ICheckGuardSuccessfulPayload): ICheckGuardSuccessfulAction =>
    createAction(CHECK_GUARD_SUCCESSFUL, payload);

export const checkGuardError = (payload: ICheckGuardErrorPayload): ICheckGuardErrorAction =>
    createAction(CHECK_GUARD_ERROR, payload);

/*
* -------------------------------------------
*        SET GUARD KEY
* -------------------------------------------
*/

export const setGuardComponentKey = (payload: ISetGuardComponentKeyPayload): TSetGuardComponentKeyAction =>
    createAction(SET_GUARD_COMPONENT_KEY, payload);

export type GuardActionType =
    ICheckGuardAction
    | ICheckGuardSuccessfulAction
    | ICheckGuardErrorAction
    | TSetGuardComponentKeyAction
